// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Col, Grid, Row } from 'react-flexbox-grid';
import InfiniteScroll from 'react-infinite-scroller';
import debounce from 'lodash/debounce';
import {
  MdClose, MdSearch, MdEvent, MdAdd,
} from 'react-icons/lib/md';
import i18n from 'i18n-js';

import * as selectors from '../../reducers/index';
import styles from './addGatewayUsersPopupContent.css';
import PopupContainer from '../PopupContainer';
import * as gatewayActions from '../../actions/gateways';
import * as closeableActions from '../../actions/closeable';
import Input from '../Input';
import PopupHeader from '../PopupHeader';
import PopupHeaderLeftGroup from '../PopupHeaderLeftGroup';
import PopupHeaderTitle from '../PopupHeaderTitle';
import PopupHeaderRightGroup from '../PopupHeaderRightGroup';
import PopupCloseButton from '../PopupCloseButton';
import PopupContent from '../PopupContent';
import PopupFooter from '../PopupFooter';
import type { GATEWAY_TYPE } from '../../types/gateways';
import HighlightColumn from '../DataTable/Columns/Highlight';
import UserColumn from '../DataTable/Columns/User';
import ButtonColumn from '../DataTable/Columns/Button';
import DataTable from '../DataTable';
import Popup from '../Popup';
import StudentSchedulingPopup from '../StudentSchedulingPopup';
import type { STUDENT_TYPE } from '../../types/student';
import AsyncTypeahead from '../Typeahead/async';
import { RenderTypeahead } from '../FieldRenderer';
import OmnisearchLoadingResults from '../OmnisearchLoadingResults';
import { generateFetcher } from '../Omnisearch/utils';
import { OMNISEARCH_RESULT_TYPES } from '../Omnisearch';
import OmnisearchResult from '../OmnisearchResult';
import { FullLoader } from '../Loader';
import { Loading } from '../CommonTexts';
import User from '../User';
import PlaceholderView from '../PlaceholderViews';
import PlaceholderImage from '../../../assets/images/genericph.png';
import Button from '../Button';
import { getUserImage } from '../../utils';


type CreateUserPopupContentPropTypes = {
  gateway: GATEWAY_TYPE,
  students: Array<STUDENT_TYPE>,
  startFetchingGatewayUsers: Function,
  open: Function,
  fetchStudents: Function,
  removeGatewayUserStarted: Function,
  addGatewayUserStarted: Function,
  areGatewayUsersFetching: boolean,
  hasMoreGatewayUser: boolean,
  gatewayUsersPage: number,
}
const processStudent = elm => (
  {
    ...elm,
    userData: {
      pictureURL: getUserImage(elm.userData.profile_picture),
      firstName: elm.userData.first_name,
      lastName: elm.userData.last_name,
      userRole: elm.type,
      size: 'small',
    },
  });
const customRenderItem = (item: Object, isHighlighted: boolean) => (
  <OmnisearchResult
    {...item}
    isSelected={isHighlighted}
    size="small"
  />
);
class CreateUserPopupContent extends React.Component<CreateUserPopupContentPropTypes> {
  constructor(props: CreateUserPopupContentPropTypes) {
    super(props);

    this.state = {
      inputValue: '',
    };

    this._debouncedMethod = debounce(this._onInputChange.bind(this), 300);
  }


  componentWillMount() {
    const { startFetchingGatewayUsers, gateway } = this.props;
    startFetchingGatewayUsers(gateway.id, {});
  }

  _onInputChange(text) {
    const {
      startFetchingGatewayUsers,
      gateway,
    } = this.props;

    this.setState(prev => ({
      ...prev,
      inputValue: text,
    }));

    const pageNumber = 1;
    startFetchingGatewayUsers(gateway.id, {
      text,
      nextPage: 1,
    });
  }

  _onFetchUsers() {
    const {
      startFetchingGatewayUsers,
      gatewayUsersPage,
      gateway,
    } = this.props;
    const { inputvalue } = this.state;
    startFetchingGatewayUsers(gateway.id, {
      text: inputvalue,
      nextPage: gatewayUsersPage,
    });
  }

  render() {
    const {
      gateway,
      startFetchingGatewayUsers,
      students,
      open,
      removeGatewayUserStarted,
      addGatewayUserStarted,
      fetchStudents,
      areGatewayUsersFetching,
      hasMoreGatewayUser,
    } = this.props;
    const processedStudents = students.map(e => processStudent(e));

    return (
      <PopupContainer size="small">
        <PopupHeader>
          <PopupHeaderLeftGroup>
            <PopupHeaderTitle title={gateway.name} size="big" />
          </PopupHeaderLeftGroup>
          <PopupHeaderRightGroup>
            <PopupCloseButton
              size="medium"
              Icon={MdClose}
              tint="mediumGray"
              clearMargins
              isTransparent
              isOutlined
            />
          </PopupHeaderRightGroup>
        </PopupHeader>
        <PopupContent className={styles.content}>
          {
            students.map(student => (
              <Popup
                id={`routesCalendar${student.id}`}
                theme="main"
                transitionType="slideDown"
                transitionMs={600}
                key={student.id}
              >
                <StudentSchedulingPopup
                  studentId={student.id}
                />
              </Popup>
            ))
          }
          <Grid>
            <Row>
              <Col xs={12}>
                <Input
                  Icon={MdSearch}
                  onChange={(e) => {
                    const text = e.target.value;
                    this._debouncedMethod(text);
                  }}
                  placeholder="Realiza tu búsqueda aquí"
                />
                <div className={styles.infiniteScrollContainer}>

                  <InfiniteScroll
                    style={{
                      touchAction: 'none'
                    }}
                    pageStart={1}
                    loadMore={this._onFetchUsers.bind(this)}
                    hasMore={hasMoreGatewayUser}
                    useWindow={false}
                    loader={
                      <Fragment>
                        {
                          areGatewayUsersFetching
                          && (
                            <div className={styles.loader}>
                              <FullLoader
                                title={Loading(i18n.t('common.gateway', { count: 2 }))}
                                key={-1}
                                tint="mediumGray"
                              />
                            </div>
                          )
                        }
                      </Fragment>
                    }
                  >
                    {
                      (processedStudents.length > 0)
                        && processedStudents.map(student => (
                          <div key={student.id} className={styles.studentContainer}>
                            <User
                              firstName={student.userData.firstName}
                              lastName={student.userData.lastName}
                              pictureURL={student.userData.pictureURL}
                              size="extraSmall"
                              theme="gatewayUser"
                            />
                            <div className={styles.userButtons}>
                              <Button
                                size="small"
                                Icon={MdEvent}
                                isOutlined={true}
                                tint="secondary"
                                isTransparent={true}
                                clearBottomMargin
                                onClick={() => open(`routesCalendar${student.id}`)}
                              />
                              <Button
                                size="small"
                                Icon={MdClose}
                                isOutlined={true}
                                tint="secondary"
                                clearBottomMargin
                                isTransparent={true}
                                onClick={() => removeGatewayUserStarted(gateway.id, parseInt(params.id, 10))}
                              />
                            </div>
                          </div>
                        ))
                    }
                    {
                      (!areGatewayUsersFetching && !processedStudents.length)
                        && (
                          <div key={-3} className={styles.placeholder}>
                            <PlaceholderView
                              size="small"
                              image={PlaceholderImage}
                              title="No se han econtrado estudiantes"
                            />
                          </div>
                        )
                    }
                    {
                      (areGatewayUsersFetching)
                      && (
                        <div key={-4} className={styles.loader}>
                          <FullLoader
                            title={Loading(i18n.t('common.gateway', { count: 2 }))}
                            key={-1}
                            tint="mediumGray"
                          />
                        </div>
                      )
                    }
                  </InfiniteScroll>
                </div>

              </Col>
            </Row>
          </Grid>
          <br />
        </PopupContent>
        <PopupFooter align="center">
          <div className={styles.footer}>
            <h3 className={styles.helpText}>{i18n.t('gateways.addStudent')}</h3>
            <AsyncTypeahead
              name="parent"
              component={RenderTypeahead}
              inputDebounce={200}
              renderSelectedValue={null}
              renderLoading={() => <OmnisearchLoadingResults size="small" count={3} />}
              fetchItems={fetchStudents}
              value={null}
              onChange={(selectedItem) => {
                addGatewayUserStarted(gateway.id, parseInt(selectedItem.user_id, 10));
              }}
              renderItem={customRenderItem}
              inputProps={{
                Icon: MdAdd,
                iconPosition: 'right',
                placeholder: 'Agrega un estudiante aquí...',
              }}
            />
          </div>
        </PopupFooter>
      </PopupContainer>
    );
  }
}
const CreateUserPopupContentComponent = connect(
  (state, props) => {
    const { gateway } = props;
    const schoolId = (selectors.getProfileOfType(state, 'admin') || {}).school || -1;
    const gatewayUsers = selectors.getGatewayUsers(state, gateway.id);
    const token = selectors.getToken(state);
    const students = [];

    gatewayUsers.forEach((u) => {
      const profile = selectors.getProfilesOfTypeFromSchool(state, u.id, 'student', schoolId);
      if (profile) {
        students.push({
          ...profile,
          userData: {
            ...u,
          },
        });
      }
    });
    const fetchStudents = generateFetcher(
      OMNISEARCH_RESULT_TYPES.student,
      schoolId,
      token,
    );
    return {
      ...props,
      students,
      fetchStudents,
      areGatewayUsersFetching: selectors.areGatewayUsersFetching(state),
      hasMoreGatewayUser: selectors.hasMoreGatewayUsers(state, gateway.id),
      gatewayUsersPage: selectors.getGatewayPage(state, gateway.id),
    };
  },
  dispatch => ({
    startFetchingGatewayUsers: (
      gatewayId,
      filters,
    ) => dispatch(gatewayActions.startFetchingGatewayUsers(gatewayId, filters)),
    open: id => dispatch(closeableActions.open(id)),
    addGatewayUserStarted: (
      id,
      userId,
    ) => dispatch(gatewayActions.addGatewayUserStarted(id, userId)),
    removeGatewayUserStarted: (
      id,
      userId,
    ) => dispatch(gatewayActions.removeGatewayUserStarted(id, userId)),
  }),
)(CreateUserPopupContent);
export default CreateUserPopupContentComponent;



// WEBPACK FOOTER //
// ./src/scripts/components/AddGatewayUsersPopupContent/index.jsx